import { useEffect, useState } from "react";
import {
  RESTAURANT_TYPE,
  SORT_BY_AZ,
  SORT_BY_DISTANCE,
  SORT_BY_PRICE,
  SORT_TYPE,
} from "../common/constants";
import { orderBy } from "lodash";
import { subscribeGetRestaurantList } from "../services";

export const useRestaurant = (props) => {
  const {
    filterById,
    filterByName,
    filterByType,
    focusSortType,
    setRestaurantList,
    setTotalLength,
    sortByAZ,
    sortByDistance,
    sortByPrice,
  } = props;
  const [tempList, setTempList] = useState([]);

  useEffect(() => {
    // Subscribe to real-time updates
    const unsubscribe = subscribeGetRestaurantList((snapshot) => {
      const data = snapshot.val();
      if (data) {
        const restaurants = Object.entries(data).map(([id, restaurant]) => ({
          ...restaurant,
          id,
          comments: restaurant?.comments
            ? Object.values(restaurant?.comments)
            : restaurant?.comments,
        }));
        setTempList(restaurants);
        setTotalLength(restaurants?.length);
      } else {
        setTempList([]);
        setTotalLength(0);
      }
    });

    // TBR
    // renameRestaurantFields();

    // Cleanup: stop listening when component unmounts
    return () => unsubscribe();
  }, [setTotalLength]);

  useEffect(() => {
    // === Apply filters & sortings ===
    let refinedList = tempList;

    // Filter
    refinedList = refinedList.filter((item) => {
      let isValid = true;
      if (filterByName) {
        isValid =
          isValid &&
          new RegExp(filterByName?.trim?.()?.toLowerCase?.(), "i").test(
            item?.name
          );
      }
      if (filterByType && filterByType !== RESTAURANT_TYPE.ALL) {
        isValid = isValid && item?.type === filterByType;
      }
      return isValid;
    });

    // Sorting
    let sortingNames = [
      (item) => item?.name?.normalize("NFD"),
      "priceFrom",
      "distance",
    ];
    let sortingDirections = [
      sortByAZ === SORT_BY_AZ.ASCENDING ? "asc" : "desc",
      sortByPrice === SORT_BY_PRICE.ASCENDING ? "asc" : "desc",
      sortByDistance === SORT_BY_DISTANCE.NEAREST ? "asc" : "desc",
    ];
    if (focusSortType === SORT_TYPE.PRICE) {
      sortingNames = [
        "priceFrom",
        (item) => item?.name?.normalize("NFD"),
        "distance",
      ];
      sortingDirections = [
        sortByPrice === SORT_BY_PRICE.ASCENDING ? "asc" : "desc",
        sortByAZ === SORT_BY_AZ.ASCENDING ? "asc" : "desc",
        sortByDistance === SORT_BY_DISTANCE.NEAREST ? "asc" : "desc",
      ];
    } else if (focusSortType === SORT_TYPE.DISTANCE) {
      sortingNames = [
        "distance",
        (item) => item?.name?.normalize("NFD"),
        "priceFrom",
      ];
      sortingDirections = [
        sortByDistance === SORT_BY_DISTANCE.NEAREST ? "asc" : "desc",
        sortByAZ === SORT_BY_AZ.ASCENDING ? "asc" : "desc",
        sortByPrice === SORT_BY_PRICE.ASCENDING ? "asc" : "desc",
      ];
    }
    refinedList = orderBy(refinedList, sortingNames, sortingDirections);

    setRestaurantList(refinedList);
    setTotalLength(refinedList?.length);
  }, [
    filterById,
    filterByName,
    filterByType,
    focusSortType,
    setRestaurantList,
    setTotalLength,
    sortByAZ,
    sortByDistance,
    sortByPrice,
    tempList,
  ]);
};
